const convertSpecialCharacters = (string: string | undefined) => {
    
    if(string === undefined) {
        return(<></>);
    }
    else {
        return <p dangerouslySetInnerHTML={ {__html: string} }/>
    }
    
}

export default convertSpecialCharacters;